import styled from 'styled-components';

import { colors, radii } from '@gbs-monorepo-packages/styles';

export const Input = styled.input`
  -webkit-appearance: none;
  background-color: none;
  border-radius: ${radii.px};
  border: none;
  color: ${colors.text};
  flex-grow: 1;
  font-size: 1rem;
  height: 3.25rem;
  line-height: 1.1;
  outline: none;
  padding: 0 1rem;
  transition:
    box-shadow 0.2s ease-in-out,
    border-color 0.2s ease-in-out;
`;

export const SelectContainer = styled.div`
  width: 100%;
  min-height: 3.25rem;
  display: block;
  & > * {
    max-width: 100%;
  }
`;

export const Loading = styled.img`
  height: 3.25rem;
  width: 3.25rem;
`;

export const Center = styled.div`
  text-align: center;
`;

export const TruncatedText = styled.span`
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
